// The Signals page, German. The shared signal vocabulary (kinds, outcomes, dispositions) lives
// in SignalsZone.de.ts, which this page loads with `severityTone`.
import { registerDe } from '../i18n/index.js';

registerDe({
  'monitors': 'Monitore',
  'runs in 24h': 'Läufe in 24 h',
  'suggested actions are proposals': 'vorgeschlagene Handlungen sind Vorschläge',
  'New monitor': 'Neuer Monitor',
  'Presets': 'Vorlagen',
  'All signals': 'Alle Signale',
  'People': 'Personen',
  'Organisations': 'Organisationen',
  'Filter signals…': 'Signale filtern…',

  // the rail
  'nothing waiting': 'nichts wartend',
  'Last 7d': 'Letzte 7 T',
  'acted on': 'entschieden',
  'no summary could be read': 'keine Übersicht lesbar',
  'Monitors': 'Monitore',
  'no target is watched yet': 'noch kein Ziel überwacht',
  'Scout': 'Scout',
  'queued': 'in Warteschlange',
  'no worker': 'kein Worker',
  'last claim {when}': 'zuletzt geholt {when}',
  'never claimed a job': 'noch nie einen Auftrag geholt',
  'refused in 24h': 'verweigert in 24 h',
  'the scout service has not answered': 'der Scout-Dienst hat nicht geantwortet',
  'LinkedIn posts': 'LinkedIn-Beiträge',
  'manual import only · LinkedIn is never fetched': 'nur manueller Import · LinkedIn wird nie abgerufen',

  // new signals
  'New signals': 'Neue Signale',
  'the quote is what the monitor read, character for character': 'das Zitat ist, was der Monitor gelesen hat, Zeichen für Zeichen',
  'When': 'Wann',
  'Kind': 'Art',
  'Concerns': 'Betrifft',
  'Signal · source · suggested action': 'Signal · Quelle · vorgeschlagene Handlung',
  'computed from what the record already holds': 'berechnet aus dem, was der Datenbestand bereits enthält',
  'Draft mail': 'Mail entwerfen',
  'Draft {ref} filed for review': 'Entwurf {ref} zur Prüfung eingereicht',
  'Nothing waiting': 'Nichts offen',
  'No signal matches this filter.': 'Kein Signal passt zu diesem Filter.',
  'No signal is waiting for a decision. Monitors run on their cadence; add one below, or enable a preset.':
    'Kein Signal wartet auf eine Entscheidung. Monitore laufen nach ihrer Taktung; fügen Sie unten einen hinzu oder aktivieren Sie eine Vorlage.',

  // monitors
  'a refusal is recorded, never a silent skip': 'eine Verweigerung wird festgehalten, nie stillschweigend übergangen',
  'Add monitor': 'Monitor hinzufügen',
  'Target': 'Ziel',
  'Target — a URL, a UID or a query': 'Ziel — eine URL, eine UID oder eine Suchanfrage',
  'Cadence': 'Taktung',
  'Cadence · hours': 'Taktung · Stunden',
  'h': 'Std.',
  'Last run': 'Letzter Lauf',
  'Outcome': 'Ergebnis',
  'never run': 'nie gelaufen',
  'Run now': 'Jetzt laufen',
  'Running…': 'Läuft…',
  'Pause': 'Pausieren',
  'Resume': 'Fortsetzen',
  'Monitor added': 'Monitor hinzugefügt',
  'Could not add the monitor.': 'Der Monitor konnte nicht hinzugefügt werden.',
  '{target}: {outcome}': '{target}: {outcome}',
  '{target}: run started': '{target}: Lauf gestartet',
  '{target}: still running — the outcome lands in the Monitors table.':
    '{target}: läuft noch — das Ergebnis erscheint in der Monitor-Tabelle.',
  'done': 'erledigt',
  'The run failed.': 'Der Lauf ist fehlgeschlagen.',
  'The monitors could not be read.': 'Die Monitore konnten nicht gelesen werden.',
  'No monitor is configured. Add one above, or enable a preset — they ship disabled, because a monitor nobody asked for is egress nobody authorised.':
    'Es ist kein Monitor konfiguriert. Fügen Sie oben einen hinzu oder aktivieren Sie eine Vorlage — sie werden deaktiviert ausgeliefert, denn ein Monitor, um den niemand gebeten hat, ist Datenverkehr, den niemand erlaubt hat.',
  'Website, careers, tender and budget targets are fetched by the scout, which respects robots.txt and never logs in. SHAB and Zefix are read from their own APIs. LinkedIn is never fetched.':
    'Website-, Stellen-, Ausschreibungs- und Budgetziele holt der Scout, der robots.txt beachtet und sich nie anmeldet. SHAB und Zefix werden über ihre eigenen APIs gelesen. LinkedIn wird nie abgerufen.',

  // presets
  'one click each · they ship disabled': 'je ein Klick · deaktiviert ausgeliefert',
  'Enable': 'Aktivieren',
  'enabled': 'aktiviert',
  'No preset is shipped.': 'Es wird keine Vorlage ausgeliefert.',

  // acted on
  'Acted on · 7d': 'Entschieden · 7 T',
  'Nothing was acted on this week.': 'Diese Woche wurde nichts entschieden.',
  'This could not be read.': 'Das konnte nicht gelesen werden.',
}, 'SignalsPage');
